<!--商户后台首页 -->
<template>
  <div
    class="amall-index-box"
    :style="{ height: $store.state.visibleHeight + 18 + 'px' }"
  >
    <!-- header -->
    <div class="flex-center">
      <!-- left -->
      <div class="amall-shop-info">
        <div class="amall-header flex justify-between">
          <div class="amall-header-left flex justify-start align-center">
            <!-- 店铺图标 -->
            <div class="amall-shop-icon amall-image-cut margin-right-sm">
              <img style="width: 112px" :src="shopInfo.shopIco" alt="" />
            </div>
            <div
              class="flex flex-direction align-start justify-center"
              style="height: 124px"
            >
              <a-tooltip placement="topLeft">
                <template slot="title">
                  <span>{{ shopInfo.shopName }}</span>
                </template>
                <div class="text-30 text-bold amall-text-cut-2">
                  {{ shopInfo.shopName }}
                </div>
              </a-tooltip>

              <!-- <div class="text-18 margin-top-xs">
                你好，{{ shopInfo.principalName }}先生
              </div> -->
            </div>
          </div>
          <div class="amall-header-right">
            <img
              style="height: 154px"
              src="../../assets/image/index-header.png"
              alt=""
            />
          </div>
        </div>
        <div class="amall-table bg-white">
          <div class="flex justify-start align-center" style="height: 64px">
            <my-title :title="['待处理订单']"></my-title>
          </div>
          <div class="padding-lr-sm" style="padding-bottom: 15px">
            <div class="amall-table-box bg-white">
              <div class="amall-table-header" style="height: 46px">
                <a-row
                  style="height: 46px"
                  type="flex"
                  align="middle"
                  justify="space-around"
                >
                  <a-col style="text-align: center" :span="4"> 订单编号 </a-col>
                  <a-col style="text-align: center" :span="4"> 下单人 </a-col>
                  <a-col style="text-align: center" :span="4"> 最终价格 </a-col>
                  <a-col style="text-align: center" :span="4"> 订购时间</a-col>
                  <a-col style="text-align: center" :span="4"> 订单状态</a-col>
                </a-row>
              </div>
              <div
                class="amall-table-content text-black text-14"
                :style="{ height: 177 + 'px' }"
                v-if="orderList.length"
              >
                <a-row
                  class="amall-table-row"
                  v-for="(item, index1) of orderList"
                  :key="index1"
                  type="flex"
                  align="middle"
                  justify="space-around"
                >
                  <a-col
                    style="text-align: center; color: var(--amall-blue)"
                    :span="4"
                    @click="openRouter(item)"
                  >
                    {{ item.orderSn }}
                  </a-col>
                  <a-col style="text-align: center" :span="4"  @click="openRouter(item)">
                    {{ item.username }}
                  </a-col>
                  <a-col style="text-align: center" :span="4"  @click="openRouter(item)">
                    {{ item.totalMoney }}
                  </a-col>
                  <a-col style="text-align: center" :span="4"  @click="openRouter(item)">
                    {{ item.createTime }}
                  </a-col>
                  <a-col style="text-align: center" :span="4"  @click="openRouter(item)"> 待发货 </a-col>
                </a-row>
              </div>
              <div
                v-else
                class="amall-table-content text-black text-14 flex-center"
                :style="{ height: 177 + 'px' }"
              >
                <a-empty description="暂无待处理订单" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- right -->
      <div class="amall-user-info">
        <div class="amall-user-image amall-image-cut">
          <img
            style="height: auto; width: 194px"
            :src="userInfo.image ? userInfo.image : shopInfo.shopIco"
            alt=""
            srcset=""
          />
        </div>
        <!-- 负责人名称 -->
        <div class="flex-center">
          <div class="amall-user-name">
            {{ userInfo.memberName }}
          </div>
        </div>
        <div class="flex-center text-black text-16">
          <div>岗位：</div>
          <div class="text-bold">{{ userInfo.memberPost }}</div>
        </div>
      </div>
    </div>
    <!-- 店铺热销 -->
    <div class="amall-hot-sale">
      <div
        class="flex justify-start align-center"
        style="height: 60px; overflow: hidden"
      >
        <my-title :title="['店铺热销']"></my-title>
      </div>
      <div class="amall-product-list" v-if="goodsList.length">
        <div
          class="amall-product-item"
          v-for="(item, index) of goodsList"
          :key="index"
        >
          <div class="amall-image-cut" style="width: 228px; height: 228px">
            <img style="width: 228px" :src="item.img" alt="" srcset="" />
          </div>
          <div class="amall-product-title">
            {{ item.goods_name }}
          </div>
          <div class="flex justify-between align-center margin-top-xs">
            <div class="text-12" style="color: rgba(60, 60, 60, 0.65)">
              累计销售：{{ item.sales }}件
            </div>
            <div class="text-price text-18 text-red">{{ item.minPrice }}</div>
          </div>
        </div>
      </div>
      <div class="amall-product-list flex justify-center align-center" v-else>
        <div style="margin: 0 auto"><a-empty description="暂无店铺热销" /></div>
      </div>
    </div>
    <div class="amall-warning-product">
      <div class="amall-table bg-white">
        <div class="flex justify-start align-center" style="height: 64px">
          <my-title :title="['库存预警']"></my-title>
        </div>
        <div class="padding-lr-sm" style="padding-bottom: 15px">
          <div class="amall-table-box bg-white">
            <div class="amall-table-header" style="height: 46px">
              <a-row
                style="height: 46px"
                type="flex"
                align="middle"
                justify="space-around"
              >
                <a-col style="text-align: center" :span="8"> 商品名称 </a-col>
                <a-col style="text-align: center" :span="4"> 规格名称 </a-col>
                <a-col style="text-align: center" :span="4"> 现有库存 </a-col>
                <a-col style="text-align: center" :span="4"> 预警库存</a-col>
                <a-col style="text-align: center" :span="4"> 设置</a-col>
              </a-row>
            </div>
            <div
              v-if="warningGoodsList.length"
              class="amall-table-content text-black text-14"
              :style="{ height: 177 + 'px', overflow: 'auto' }"
            >
              <a-row
                class="amall-table-row"
                v-for="(item, index1) of warningGoodsList"
                :key="index1"
                type="flex"
                align="middle"
                justify="space-around"
              >
                <a-col style="text-align: center" :span="8">
                  <div class="amall-warning-title">
                    {{ item.goods_name }}
                  </div>
                </a-col>
                <a-col style="text-align: center" :span="4">
                  <div class="amall-warning-title">
                    {{ item.spec_name }}
                  </div>
                </a-col>
                <a-col style="text-align: center" :span="4">
                  {{ item.stock }}
                </a-col>
                <a-col style="text-align: center" :span="4">
                  {{ item.stock_alert }}
                </a-col>
                <a-col style="text-align: center" :span="4">
                  <div class="amall-go-edit" @click="goUpdata(item)">
                    去修改
                  </div>
                </a-col>
              </a-row>
            </div>
            <div
              v-else
              class="amall-table-content text-black text-14 flex-center"
              :style="{ height: 177 + 'px', overflow: 'auto' }"
            >
              <a-empty description="暂无库存预警" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shop_message } from "@/service/shop_h.js";
import { findOrderListWeb } from "@/service/order.js";
import { findLogin } from "@/service/user.js";
import {
  getShopSellWellGoodsList,
  getShopInventoryWarnGoodsList,
} from "@/service/goods.js";

import * as utils from "@/utils/utils";
export default {
  name: "",
  data() {
    return {
      shopInfo: {},
      orderList: [],
      goodsList: [],
      warningGoodsList: [],
      userInfo: {},
    };
  },
  created() {
    shop_message().then((res) => {
      this.shopInfo = res.data;
    });
    this.getOrderList();
    this.getHotGoodsList();
    this.getWarningGoodsList();
    this.getUserInfo();
  },
  methods: {
    goUpdata(item) {
      console.log(item);
      this.$router.push(
        `/updata_product?updata=true&progress=2&goodsId=${item.goods_id}`
      );
    },
    getUserInfo() {
      findLogin().then((res) => {
        if (res.flag) {
          this.userInfo = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getWarningGoodsList() {
      getShopInventoryWarnGoodsList().then((res) => {
        if (res.flag) {
          this.warningGoodsList = res.data;
        }
      });
    },
    getHotGoodsList() {
      getShopSellWellGoodsList().then((res) => {
        if (res.flag) {
          res.data.forEach((item) => {
            item.img = item.goods_image.split(",")[0];
          });
          this.goodsList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getOrderList() {
      findOrderListWeb({
        orderSn: "",
        overTime: "",
        pageNum: this.page,
        pageSize: 4,
        startTime: "",
        status: 4,
        username: "",
      }).then((res) => {
        if (res.flag) {
          this.orderList = res.data.list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 点击待处理订单，跳转到对应的订单详情页面
    openRouter(item) {
      this.$router.push("/control_order?&orderSn=" + item.orderSn);
    },
  },
};
</script>
<style scoped lang="scss">
.amall-index-box {
  background: #f4f5f9;
  overflow: auto;
}
.amall-shop-info {
  width: 100%;
  height: 500px;
}
.amall-user-info {
  margin-left: 20px;
  width: 323px;
  height: 500px;
  flex-shrink: 0;
  background: url(https://amall360-2.oss-cn-hangzhou.aliyuncs.com/amall360-2/images/1453993646218153984.png)
    no-repeat;
  background-color: white;
  display: flex;
  align-content: center;
  flex-direction: column;
}
.amall-user-image {
  width: 194px;
  height: 262px;
  margin: 0 auto;
  margin-top: 56px;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 8px;
}
.amall-user-name {
  margin-top: 28px;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  display: inline-block;
  width: auto;
  position: relative;
  background-color: transparent;
  z-index: 1;
}
.amall-user-name::after {
  position: absolute;
  content: " ";
  bottom: 6px;
  width: 100%;
  height: 8px;
  left: 0;
  z-index: -1;
  background-color: var(--amall-green);
}
.amall-header {
  padding-left: 30px;
  padding-right: 88px;
  width: 100%;
  background-color: white;
}
.amall-header-left {
  height: 173px;
}
.amall-header-right {
  margin-top: 20px;
}
.amall-shop-icon {
  width: 124px;
  height: 124px;
  background-color: rgba(126, 126, 126, 0.14);
}
.amall-table {
  margin-top: 23px;
}
.amall-table-row {
  height: 44px;
  border-bottom: 1px solid #e8edf3;
  cursor: pointer;
}
.amall-hot-sale {
  width: 100%;
  height: 385px;
  background-color: white;
  margin-top: 20px;
}
.amall-product-list {
  width: 100%;
  height: 306px;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  overflow: auto;
}
.amall-product-item {
  width: 228px;
  height: 306px;
  margin-right: 44px;
  flex-shrink: 0;
}
.amall-product-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.amall-warning-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.amall-warning-product {
  background-color: white;
  margin-top: 20px;
}
.amall-go-edit {
  width: 57px;
  height: 25px;
  text-align: center;
  align-content: 25px;
  border: 1px solid var(--amall-blue);
  opacity: 1;
  border-radius: 3px;
  color: var(--amall-blue);
  margin: 0 auto;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue